/* ------------------------------------*\
    VARIABLE DECLARATION
\*------------------------------------*/
$(window).on('load', () => {
    /*------------------------------------*\
        CALL TO FUNCTIONS
    \*------------------------------------*/


    if (isProductArchive()) {
        // console.log(
        //     '<!-- ----------------------------------------------------- -->\n' +
        // '<!-- Product Archive-->\n' +
        // '<!-- ----------------------------------------------------- -->');
        setupArchiveProduct();

    }

});

/*------------------------------------*\
Single Product
\*------------------------------------*/
function setupArchiveProduct() {
    //specific for mobile
    if(deviceDetector.device == 'desktop'){
        // You're on a desktop.
        // console.log('desktop');
    }else{
        if(deviceDetector.device == 'tablet'){
            // You're on a tablet.
            // console.log('tablet');
        }else{
            // console.log('phone');
        }
        // You're on a phone.
    }

    setupArchiveProducts_navigation();
}

function setupArchiveProducts_navigation(){
    var $nav_items = $('.a-product-menu-item');

    $nav_items.on('click',function(){
        var category = $(this).data('c-slug');

        $nav_items.removeClass('active');
        $(this).addClass('active');
        filterElementsNavigationArchiveProducts(category);
    });
}

function filterElementsNavigationArchiveProducts( category ){
    var $grid_items = $('.product-grid-item');

    if(category === 'all'){
        $grid_items.fadeOut(0);
        setTimeout(function(){
            $grid_items.addClass('fadeInItem');
            $grid_items.each(function(){
                var t = this;
                $(t).stop(true,true).fadeTo(300, 1);
            });
        },100);

    }else{
        $grid_items.fadeOut(0);
        setTimeout(function(){
            var count = 0;
            $grid_items.each(function(){
                if($(this).data('cats').includes(category)){
                    var t = this;
                    $(t).stop(true,true).fadeTo(300, 1);
                    count++;
                }
            });
        },100);
    }
}
